import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlComponent, DynamicFormControlCustomEvent, DynamicFormLayoutService, DynamicFormValidationService } from '@ng-dynamic-forms/core';
import {NumericTextboxModel} from './numeric-textbox.model';
import { COMPONENT_MODE } from '../workflow-components.models';

@Component({
  selector: 'dynamic-numeric-textbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-numeric-textbox.component.html'
})
export class DynamicNumericTextboxComponent extends DynamicFormControlComponent {
  @Input() bindId = true;
  @Input() group: FormGroup;
  @Input() model: NumericTextboxModel;
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();
  COMPONENT_MODE = COMPONENT_MODE;
  constructor(protected layoutService: DynamicFormLayoutService, protected validationService: DynamicFormValidationService) {
    super(layoutService, validationService);
  }
}
